module.exports = __webpack_public_path__ + "img/slide-12.bd95d27e.jpg";